import React from 'react';
import { COLOR_PICKERS } from './ColorStyles';
import ColorPicker from './ColorPicker';
import { getSelectionCustomInlineStyle } from 'draftjs-utils';


function ColorStyles({ editorState, handleFocus, onToggle }) {

    const colorStyle = {
        color: getSelectionCustomInlineStyle(editorState, ['COLOR']).COLOR,
        bgcolor: getSelectionCustomInlineStyle(editorState, ['BGCOLOR']).BGCOLOR
    }

    return (
        <>
            {COLOR_PICKERS.map((control, i) => {
                const style = colorStyle[control.value];
                const color = style ? style.split('-')[1] : '';
                return (
                    <ColorPicker
                        key={i}
                        onToggle={onToggle}
                        handleFocus={handleFocus}
                        color={color}
                        control={control}
                    />
                )
            })}

        </>
    )
};

export default ColorStyles;
